"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extension_1 = require("../extension");
class TwingExtensionStaging extends extension_1.TwingExtension {
    constructor() {
        super(...arguments);
        this.functions = new Map();
        this.filters = new Map();
        this.visitors = [];
        this.tokenParsers = new Map();
        this.tests = [];
    }
    addFunction(twingFunction) {
        if (this.functions.has(twingFunction.getName())) {
            throw new Error(`Function "${twingFunction.getName()}" is already registered.`);
        }
        this.functions.set(twingFunction.getName(), twingFunction);
    }
    getFunctions() {
        return this.functions;
    }
    addFilter(filter) {
        if (this.filters.has(filter.getName())) {
            throw new Error(`Filter "${filter.getName()}" is already registered.`);
        }
        this.filters.set(filter.getName(), filter);
    }
    getFilters() {
        return this.filters;
    }
    addNodeVisitor(visitor) {
        this.visitors.push(visitor);
    }
    getNodeVisitors() {
        return this.visitors;
    }
    addTokenParser(parser) {
        if (this.tokenParsers.has(parser.getTag())) {
            throw new Error(`Tag "${parser.getTag()}" is already registered.`);
        }
        this.tokenParsers.set(parser.getTag(), parser);
    }
    getTokenParsers() {
        return Array.from(this.tokenParsers.values());
    }
    addTest(test) {
        this.tests.push(test);
    }
    getTests() {
        return this.tests;
    }
}
exports.TwingExtensionStaging = TwingExtensionStaging;
